import { TrackerProgressTile, TrackerProgressTileProps } from "../TrackerProgressTile";

import { ReactComponent as ActivityIcon } from "@icons/activity.svg";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";

interface GeneralActivityTrackerProgressTileProps {
  inCard?: boolean;
  size?: TrackerProgressTileProps["size"];
}

export const GeneralActivityTrackerProgressTile = ({ inCard = true, size = "lg" }: GeneralActivityTrackerProgressTileProps) => {
  const { t } = useTranslation();
  return (
    <TrackerProgressTile
      trackerType={TrackerType.Activity}
      trackerPagePath="general-activity"
      Icon={ActivityIcon}
      wrapInCard={inCard}
      size={size}
      caption={t("wellbeing.trackers.activity.caption")}
    />
  );
};
